<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LabelContainer',
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    labelWidth: {
      type: String, // 'sm' | 'lg'
      default: 'sm'
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    isDisplayNone: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    return {
      labelWidthClass: `label-width-${props.labelWidth}`
    }
  }
})
</script>

<template>
  <div class="d-flex mb-4 align-items-center w-100">
    <label
      v-if="showLabel"
      :for="name"
      class="form-label me-3 fs-4 w-25"
      :class="isDisplayNone === true ? 'd-none' : ''"
    >
      <slot name="label">{{ label }}</slot>
    </label>
    <div class="flex-grow d-flex justify-content-end">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped></style>
